import i18n from '../i18n';
import { api, getAccessToken, ApiError } from './client';
import type { ReleaseDto } from './types';

export function latestReleases(): Promise<ReleaseDto[]> {
  return api('/api/v1/releases/latest');
}

export function adminReleases(): Promise<ReleaseDto[]> {
  return api('/api/v1/admin/releases');
}

export function adminDeleteRelease(id: string): Promise<void> {
  return api(`/api/v1/admin/releases/${id}`, { method: 'DELETE' });
}

/** Загрузка сборки через XHR — fetch не умеет прогресс отправки (MSI бывают в сотни МБ). */
export function adminUploadRelease(
  form: { platform: string; version: string; notes?: string; file: File },
  onProgress: (pct: number) => void,
): Promise<ReleaseDto> {
  return new Promise((resolve, reject) => {
    const fd = new FormData();
    fd.append('platform', form.platform);
    fd.append('version', form.version);
    if (form.notes) fd.append('notes', form.notes);
    fd.append('file', form.file);
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/v1/admin/releases');
    const access = getAccessToken();
    if (access) xhr.setRequestHeader('Authorization', 'Bearer ' + access);
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100));
    };
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        try { resolve(JSON.parse(xhr.responseText)); } catch { reject(new ApiError(500, i18n.t('misc2:releasesInvalidResponse'))); }
        return;
      }
      let detail = i18n.t('misc2:releasesUploadFailed');
      try { detail = JSON.parse(xhr.responseText).detail || detail; } catch { /* не JSON */ }
      reject(new ApiError(xhr.status, detail));
    };
    xhr.onerror = () => reject(new ApiError(0, i18n.t('misc2:releasesNetworkError')));
    xhr.send(fd);
  });
}
